import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {SpinnerComponent} from './shared/components/spinner/spinner.component';
import {Spinkit} from 'ng-http-loader';
import {TranslateService} from '@ngx-translate/core';
import {StorageService} from './services/storage.service';
import {InactivityTimerService} from "./services/inactivity-timer.service";
import {Store} from "@ngrx/store";
import {AppState} from "./store/reducers";
import {getAllTranslations} from "./store/entities/system-settings/translation/translation.actions";
import {SettingsService} from "./services/settings.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'tgsd_frontend';
  public spinnerComponent = SpinnerComponent;
  public spinkit = Spinkit;

  private scriptId = 'chatwoot-sdk-script';

  hasLoggedIn: boolean = false;

  constructor(
    private translate: TranslateService,
    private storageService: StorageService,
    private inactivityTimerService: InactivityTimerService,
    private store: Store<AppState>,
    private settingsService: SettingsService,
  ) {
    translate.setDefaultLang('en');
    translate.use(this.storageService.getItem('language') || 'en');
  }

  @HostListener('document:mousemove')
  @HostListener('document:click')
  @HostListener('document:keypress')
  refreshUserActivity(): void {
    this.inactivityTimerService.refreshUserActivity();
  }

  ngOnInit() {

    this.store.dispatch(getAllTranslations());

    this.settingsService.loadTranslation()

    if (!this.storageService.getItem('currentClient')) {
      this.addChatwootScript()
    } else {
      this.hasLoggedIn = true;
    }
    const iframeWrapper = document.querySelector('.iframe-wrapper');

    if (iframeWrapper) {
      iframeWrapper.addEventListener('click', () => {
        console.log('Iframe clicked!');
      });
    } else {
      console.error('Iframe wrapper not found.');
    }



    this.translate.addLangs(['en', 'sw']);

    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'sw');
      this.translate.setDefaultLang('sw');
      this.translate.use('sw');
    } else {
      this.translate.use(localStorage.getItem('lang'));
      this.translate.setDefaultLang(localStorage.getItem('lang'));
    }
  }

  ngOnDestroy(): void {
    this.inactivityTimerService.resetTimer();
  }


  private addChatwootScript() {

    const script = document.createElement('script');
    script.id = this.scriptId;
    script.src = 'https://chatcenter.ccds.all.tz/packs/js/sdk.js';
    script.defer = true;
    script.async = true;
    script.onload = () => {
      (window as any).chatwootSDK.run({
        websiteToken: 'NfTidb5YzrvHVnw4g9xiHdNK',
        baseUrl: 'https://chatcenter.ccds.all.tz'
      });
    };
    document.head.appendChild(script);
  }

}
